module.exports = __webpack_public_path__ + "img/lv4.c93213ce.png";